import {
  getQueryString
} from '@/utils/common'
import '@flashex-fe-comp/fe-bd-js-sdk'
import { bdHelper } from '@flashex-fe/iss-fe-utils'

const { bdQuick, bdStatisticHandle } = bdHelper

// 页面点击事件
export const bdCommonTrack = (name: string, customParams: object) => {
  // sdk自带uid，公共默认参数
  const defaultParams = {
    uid: getQueryString('courierId') || '',
    cityCode: getQueryString('cityCode') || '',
    longId: getQueryString('shansongId') || ''
  }
  const mergeParams = { ...defaultParams, ...customParams }
  bdStatisticHandle(name, mergeParams)
  // bd.track(name, mergeParams);
}
// 进入页面使用
export const bdCommonQuick = (customParams: object) => {
  const defaultParams = {
    uid: getQueryString('courierId') || '',
    cityCode: getQueryString('cityCode') || '',
    longId: getQueryString('shansongId') || ''
  }
  const mergeParams = { ...defaultParams, ...customParams }
  bdQuick(mergeParams)
  // bd.quick('autoTrackSinglePage', mergeParams);
}
